export const invoice = {
    labels: {
        all: "Todas",
        pending: "Pendente",
        paid: "Pago",
        canceled: "Cancelado",
        refunded: "Extornado",
        expired: "Expiradas",
        history: "Histórico",
        plan: "Plano",
        service: "Serviço",
        date: "Data",
        type: "Tipo",
        value: "Valor",
        status: "Status",
        quantity: "Quantidade",
        product: "Produto",
        month: "Mês",
        init: "Início",
        end: "Fim",
        start_date: "Data de Início",
        end_date: "Data de Fim",
        entrances: "Entradas",
        outputs: "Saídas",
        final: "Final",
        member: "Membro",
        name: "Nome",
    },
    enum: {
        product_type: {
            "PLAN": "Plano",
            "SERVICE": "Serviço",
        },
        currency: {
            "BRL": "R$",
            "USD": "$",
            "EUR": "€",
        },
        status: {
            "DRAFT": "Pendente",
            "SENT": "Pendente",
            "PENDING": "Pendente",
            "PARTIALLY_PAID": "Pendente",
            "PAID": "Pago",
            "MARKED_AS_PAID": "Pago",
            "CANCELLED": "Cancelado",
            "REFUNDED": "Extornado",
            "MARKED_AS_REFUNDED": "Extornado",
        }
    },
    modals: {
        titles: {
        },
        messages: {
        }
    },
    texts: {
    },
};
